<template>
    <el-dialog
        :visible.sync="dialogShopOrder.dialogShow"
        width="80%"
        :close-on-press-escape="false"
        :close-on-click-modal="false"
        custom-class="loadingShopOrderMobile"
        >
         <dialogCreateShipment :dialogCreateShipment.sync="dialogCreateShipment" @refreshAllOrder="onRefreshAllOrder"/>
        <el-row>
            <el-col :span="24" class="text-md-left" style="font-size:30px;font-weight: bold;">{{dialogShopOrder.detail.shopName}}</el-col>
        </el-row>
        <el-row :gutter="20">
            <el-col :span="8" class="text-md-left" style="font-size:18px;font-weight: bold;">สถานะ : {{dialogShopOrder.detail.status ? dialogShopOrder.detail.status : '-'}}</el-col>
            <el-col :span="8" class="text-md-left" style="font-size:18px;font-weight: bold;">วันที่ : {{dialogShopOrder.detail.remark ? dialogShopOrder.detail.remark : '-'}}</el-col>
            <el-col :span="8" class="text-md-left" style="font-size:18px;font-weight: bold;">เวลา : {{dialogShopOrder.detail.bookTime ? dialogShopOrder.detail.bookTime : '-'}}</el-col>
        </el-row>
        <hr>
        <el-row>
            <el-col :span="12" class="text-md-left">
                <el-checkbox-group v-model="statusSelect" @change="onSelectStatus" :min="1" class="disableCheckStatus">
                    <el-checkbox-button v-for="status in statusList" :label="status.id" :key="status.id" >{{status.name}} ({{status.count}})</el-checkbox-button>
                </el-checkbox-group>
            </el-col>
            <el-col :span="12" class="text-md-right">
                <el-button plain >{{multipleSelection.length}} ออเดอร์ที่เลือก</el-button>
                <el-button type="primary" @click="createShipment">Create Shipment</el-button>
            </el-col>
            <el-col :span="12" class="text-md-left" style="margin-top:5px;">
                <el-radio-group v-model="editArray" @change="onSelectStatus" >
                    <el-radio-button v-for="status in statusSave" :label="status.id" :key="status.id">{{status.name}} ({{status.count}})</el-radio-button>
                </el-radio-group>
            </el-col>
            <el-col :span="12" class="text-md-right" style="margin-top:5px;">
                <el-radio-group v-model="printStatusSelect" @change="onSelectStatus" :disabled="diableOrderStatusFalse">
                    <el-radio-button v-for="dataPrint in statusPrint" :key="dataPrint.id" :label="dataPrint.value">{{dataPrint.name}} ({{dataPrint.count}})</el-radio-button>
                </el-radio-group>
            </el-col>
        </el-row>
        <hr>
        <el-row>
            <el-col :span="24" >
            <div style="overflow-x:auto;" class="tableMobile">
                     <table>
                        <thead>
                            <tr>
                                <th><input
                                    type="checkbox"
                                    v-model="checkAll"
                                    @change="handleSelectionChangeCheckAll"
                                ></th>
                                <th></th>
                            </tr>
                        </thead>
                        <tbody v-if="itemList.length > 0">
                            <template v-for="(item, index) in itemList" >
                                <tr :key="index">
                                    <td valign="top" style="width:20px;">
                                        <input
                                            type="checkbox"
                                            :id="item.orderNumber"
                                            :value="{...item}"
                                            v-model="multipleSelection"
                                            @change="handleSelectionChange"
                                        >
                                    </td>
                                    <td>
                                         <form @submit.prevent="validateForm('form-'+index,index)" :data-vv-scope="'form-'+index">
                                        <el-row :gutter="20">
                                            <el-col :span="17" :offset="7">
                                                <p style="margin-bottom:0px;">Raw Address</p>
                                                <div style="font-size:26px;font-weight: bold;">{{item.rawAddress}}</div>
                                            </el-col>
                                            <el-col :span="7">
                                                <el-row>
                                                    <el-col :span="24">
                                                        <div class="sub-title"><span style="color:#f56c6c">* </span>ชื่อ - นามสกุล :</div>
                                                        <input
                                                            type="text"
                                                            name="shippingName"
                                                            v-validate="'required|max:50'"
                                                            data-vv-as="ชื่อ - นามสกุล"
                                                            autocomplete="off"
                                                            placeholder="ชื่อ - นามสกุล"
                                                            v-model="item.shippingName"
                                                            class="el-input__inner"
                                                            :class="{ 'input-is-error': errors.has('form-'+index+'.shippingName') }">
                                                        <div class="el-form-item__error" v-if="errors.has('form-'+index+'.shippingName')">
                                                            {{ errors.first('form-'+index+'.shippingName') }}
                                                        </div>
                                                    </el-col>
                                                     <el-col :span="24" style="margin-bottom:10px;">
                                                        <div class="sub-title"><span style="color:#f56c6c">* </span>เบอร์โทร :</div>
                                                        <input
                                                            type="text"
                                                            name="shippingPhoneNumber"
                                                            v-validate="'required|min:9|max:10|numeric|phoneNumber'"
                                                            data-vv-as="เบอร์โทร"
                                                            autocomplete="off"
                                                            placeholder="เบอร์โทร"
                                                            v-model="item.shippingPhoneNumber"
                                                            class="el-input__inner"
                                                            :class="{ 'input-is-error': errors.has('form-'+index+'.shippingPhoneNumber') }">
                                                        <div class="el-form-item__error" v-if="errors.has('form-'+index+'.shippingPhoneNumber')">
                                                            {{ errors.first('form-'+index+'.shippingPhoneNumber') }}
                                                        </div>
                                                    </el-col>
                                                    <el-col :span="24" style="margin-bottom:10px;">
                                                        <p style="margin-bottom:0px;"><b>Shop Name</b></p>
                                                         {{item.shopName}}
                                                    </el-col>
                                                    <el-col :span="24" style="margin-bottom:10px;">
                                                        <p style="margin-bottom:0px;"><b>Status</b></p>
                                                        {{getOrderStatus(item.orderStatus)}}
                                                    </el-col>
                                                    <el-col :span="24">
                                                        <p style="margin-bottom:0px;"><b>Order Number</b></p>
                                                       <template v-if="permission.isOutSourceMobileOrder">
                                                            {{ item.orderNumber }}
                                                        </template>
                                                        <template v-else>
                                                           <a href="#" @click="handleOrderNumberDetail(item.orderNumber)">{{ item.orderNumber }}</a>
                                                        </template>
                                                    </el-col>
                                                    <el-col :span="24">
                                                         <el-tag v-bind:style="getCourierObject(item.courierId).styleTag">{{ getCourier(item.courierId) }}</el-tag>
                                                    </el-col>
                                                </el-row>
                                            </el-col>
                                            <el-col :span="17">
                                                <el-row :gutter="20">
                                                    <el-col :span="24">
                                                        <div class="sub-title">ค้นหาที่อยู่ :</div>
                                                        <el-autocomplete
                                                            :ref="`txt_autoCompleteSelectAddress${index}`"
                                                            class="inline-input"
                                                            v-model.lazy="searchAddressTable[index]"
                                                            autocomplete="off"
                                                            :loading="searchAddressLoading"
                                                            placeholder="ค้นหา"
                                                            :trigger-on-focus="false"
                                                            style="width: 100%;"
                                                            :fetch-suggestions="getAddressInfoFromdataBase"
                                                            @paste.native.prevent="autoSetupSearchAddress($event, index)"
                                                            @select="handleSelect($event,index)">
                                                            <template slot-scope="{ item }">
                                                                <div style="color: #000; font-size:14px; font-weight:400;">{{ `${ item.subDistrictName } >> ${ item.districtName } >> ${ item.provinceName } >> ${ item.detail }` }}</div>
                                                            </template>
                                                        </el-autocomplete>
                                                    </el-col>
                                                    <el-col :span="24">
                                                        <div class="sub-title"><span style="color:#f56c6c">* </span>ที่อยู่ :</div>
                                                        <input
                                                            type="text"
                                                            name="shippingAddress"
                                                            v-validate="{ required: true, max: flashCurrierMaxLength(item) }"
                                                            data-vv-as="ที่อยู่"
                                                            autocomplete="off"
                                                            placeholder="ที่อยู่"
                                                            v-model="item.shippingAddress"
                                                            class="el-input__inner"
                                                            :class="{ 'input-is-error': errors.has('form-'+index+'.shippingAddress') }">
                                                            <el-row>
                                                                <el-col :span="12">
                                                                    <div class="el-form-item__error" >
                                                                        {{ errors.first('form-'+index+'.shippingAddress') }}
                                                                    </div>
                                                                </el-col>
                                                                <el-col :span="12" class="text-right" :class="errors.has('form-'+index+'.shippingAddress') ? 'couter-error': null">
                                                                     <div>{{item.shippingAddress.length}}/{{flashCurrierMaxLength(item)}}</div>
                                                                </el-col>
                                                            </el-row>
                                                    </el-col>
                                                </el-row>
                                                <el-row>
                                                    <el-col :span="12">
                                                        <div class="sub-title"><span style="color:#f56c6c">* </span>ตำบล :</div>
                                                        <div>
                                                        <el-row style="margin-bottom: 0px;">
                                                            <el-col :span="21">
                                                                <input
                                                                    type="text"
                                                                    name="shippingSubDistrict"
                                                                    v-validate="'required'"
                                                                    data-vv-as="ตำบล"
                                                                    autocomplete="off"
                                                                    placeholder="ตำบล"
                                                                    v-model="item.shippingSubDistrict"
                                                                    class="el-input__inner"
                                                                    :class="{ 'input-is-error': errors.has('form-'+index+'.shippingSubDistrict') }"
                                                                >
                                                            </el-col>
                                                            <el-col :span="3">
                                                                <i v-if="isLoadingCheckAddress[index]" class="el-icon-loading" style="color:rgb(8, 167, 163);font-weight: bold;font-size: 26px;"></i>
                                                                <i v-if="!subDistrictInvalid[index] && !isLoadingCheckAddress[index]" class="el-icon-close" style="color:red;font-weight: bold;font-size: 26px;"></i>
                                                                <i v-if="subDistrictInvalid[index] && !isLoadingCheckAddress[index]"  class="el-icon-check" style="color:green;font-weight: bold;font-size: 26px;"></i>
                                                            </el-col>
                                                        </el-row>
                                                        </div>
                                                        <div class="el-form-item__error" v-if="errors.has('form-'+index+'.shippingSubDistrict')">
                                                            {{ errors.first('form-'+index+'.shippingSubDistrict') }}
                                                        </div>
                                                    </el-col>
                                                    <el-col :span="12">
                                                    <div class="sub-title"><span style="color:#f56c6c">* </span>อำเภอ :</div>
                                                    <div>
                                                        <el-row style="margin-bottom: 0px;">
                                                            <el-col :span="21">
                                                                <input
                                                                    type="text"
                                                                    name="shippingDistrict"
                                                                    v-validate="'required'"
                                                                    data-vv-as="อำเภอ"
                                                                    autocomplete="off"
                                                                    placeholder="อำเภอ"
                                                                    v-model="item.shippingDistrict"
                                                                    class="el-input__inner"
                                                                    :class="{ 'input-is-error': errors.has('form-'+index+'.shippingDistrict') }"
                                                                >
                                                            </el-col>
                                                            <el-col :span="3">
                                                                <i v-if="isLoadingCheckAddress[index]" class="el-icon-loading" style="color:rgb(8, 167, 163);font-weight: bold;font-size: 26px;"></i>
                                                                <i v-if="!districtInvalid[index] && !isLoadingCheckAddress[index]" class="el-icon-close" style="color:red;font-weight: bold;font-size: 26px;"></i>
                                                                <i v-if="districtInvalid[index] && !isLoadingCheckAddress[index]" class="el-icon-check" style="color:green;font-weight: bold;font-size: 26px;"></i>
                                                            </el-col>
                                                        </el-row>
                                                    </div>
                                                    <div class="el-form-item__error" v-if="errors.has('form-'+index+'.shippingDistrict')">
                                                        {{ errors.first('form-'+index+'.shippingDistrict') }}
                                                    </div>
                                                </el-col>
                                                </el-row>
                                                <el-row>
                                                <el-col :span="12">
                                                    <div class="sub-title"><span style="color:#f56c6c">* </span>จังหวัด :</div>
                                                    <div>
                                                        <el-row style="margin-bottom: 0px;">
                                                            <el-col :span="21">
                                                                <input
                                                                    v-model="item.shippingProvince"
                                                                    :class="{ 'input-is-error': errors.has('form-'+index+'.shippingProvince') }"
                                                                    type="text"
                                                                    name="shippingProvince"
                                                                    v-validate="'required'"
                                                                    data-vv-as="จังหวัด"
                                                                    autocomplete="off"
                                                                    placeholder="จังหวัด"
                                                                    class="el-input__inner"
                                                                >
                                                            </el-col>
                                                            <el-col :span="3">
                                                                <i v-if="isLoadingCheckAddress[index]" class="el-icon-loading" style="color:rgb(8, 167, 163);font-weight: bold;font-size: 26px;"></i>
                                                                <i v-if="!provinceInvalid[index] && !isLoadingCheckAddress[index]" class="el-icon-close" style="color:red;font-weight: bold;font-size: 26px;"></i>
                                                                <i v-if="provinceInvalid[index] && !isLoadingCheckAddress[index]" class="el-icon-check" style="color:green;font-weight: bold;font-size: 26px;"></i>
                                                            </el-col>
                                                        </el-row>
                                                    </div>
                                                    <div class="el-form-item__error" v-if="errors.has('form-'+index+'.shippingProvince')">
                                                        {{ errors.first('form-'+index+'.shippingProvince') }}
                                                    </div>
                                                </el-col>
                                                <el-col :span="12">
                                                    <div class="sub-title"><span style="color:#f56c6c">* </span>รหัสไปรษณีย์ :</div>
                                                    <div>
                                                    <el-row style="margin-bottom: 0px;">
                                                        <el-col :span="21">
                                                            <input
                                                                v-model="item.shippingZipcode"
                                                                :class="{ 'input-is-error': errors.has('form-'+index+'.shippingZipcode') }"
                                                                type="text"
                                                                name="shippingZipcode"
                                                                v-validate="'required|min:5|max:5|numeric'"
                                                                data-vv-as="รหัสไปรษณีย์"
                                                                autocomplete="off"
                                                                placeholder="รหัสไปรษณีย์"
                                                                class="el-input__inner"
                                                            >
                                                        </el-col>
                                                        <el-col :span="3">
                                                            <i v-if="isLoadingCheckAddress[index]" class="el-icon-loading" style="color:rgb(8, 167, 163);font-weight: bold;font-size: 26px;"></i>
                                                            <i v-if="!zipcodeInvalid[index] && !isLoadingCheckAddress[index]" class="el-icon-close" style="color:red;font-weight: bold;font-size: 26px;"></i>
                                                            <i v-if="zipcodeInvalid[index] && !isLoadingCheckAddress[index]" class="el-icon-check" style="color:green;font-weight: bold;font-size: 26px;"></i>
                                                        </el-col>
                                                    </el-row>
                                                    </div>
                                                    <div class="el-form-item__error" v-if="errors.has('form-'+index+'.shippingZipcode')">
                                                        {{ errors.first('form-'+index+'.shippingZipcode') }}
                                                    </div>
                                                </el-col>
                                                </el-row>
                                                <el-row>
                                                    <el-col :span="12">
                                                        <div class="sub-title">หมายเหตุ :</div>
                                                        <textarea name="note"
                                                        autocomplete="off"
                                                        data-vv-as="หมายเหตุ"
                                                        v-model="item.note"
                                                        placeholder="หมายเหตุ"
                                                        class="el-textarea__inner"
                                                         :class="{ 'input-is-error': errors.has('form-'+index+'.note') }"></textarea>
                                                        <div class="el-form-item__error" v-if="errors.has('form-'+index+'.note')">
                                                            {{ errors.first('form-'+index+'.note') }}
                                                        </div>
                                                    </el-col>
                                                    <el-col :span="12">
                                                        <div style="margin-top:26px;padding-right:50px" class="text-right">
                                                            <el-button type="primary" native-type="submit" :loading="item.loading" style="margin-right:10px;">บันทึก</el-button>
                                                            <b v-if="item.isAppEdit">
                                                                <i class="el-icon-check" style="color:green;font-weight: bold;font-size: 26px;"></i>
                                                            </b>
                                                            <b v-else>
                                                                <i class="el-icon-close" style="color:red;font-weight: bold;font-size: 26px;"></i>
                                                            </b>
                                                        </div>
                                                        <!-- <div style="margin-bottom:10px;"> -->

                                                        <!-- </div> -->
                                                    </el-col>
                                                </el-row>
                                            </el-col>
                                        </el-row>
                                        </form>
                                    </td>
                                </tr>
                            </template>
                        </tbody>
                        <tbody v-else>
                            <tr>
                                <td colspan="7">
                                    <div class="text-md-center">
                                        <b>ไม่พบข้อมูล</b>
                                    </div>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                    </div>
            </el-col>
            <el-col style="margin-top:10px;" class="text-md-center">
                <el-pagination
                @size-change="changeLimitPage"
                @current-change="changeCurrentPage"
                :current-page.sync="pagination.currentPage"
                :page-sizes="pagination.pageSizes"
                :page-size="10"
                layout="prev, pager, next, sizes"
                :total="pagination.allPage * pagination.limit"
                ></el-pagination>
            </el-col>
        </el-row>

    </el-dialog>
</template>

<script>
import fgApi from '@/services/fillgoods'
import dialogCreateShipment from '@/components/LogOrder/dialogCreateShipmentMobile.vue'
import MixinThailandUtility from '@/mixins/thailandUtility.js'
import { COURIER_FLASH } from '@/utils/orderUtils.js'
import { Validator } from 'vee-validate'
import { get } from 'vuex-pathify'
import MixinOrderUtility from '@/mixins/orderUtility.js'
// import { flashZipcodeCovid } from '@/utils/zipcodeCovidUtils.js'

const phone = value => {
    const telephonePostfix = ['02', '03', '04', '05', '07']
    let valueString = String(value)
    let dataReturn = {}
    if (valueString.length > 0) {
        if (valueString[0] === '0') {
            let phoneFirstTwoDigit = valueString.substring(0, 2)
            let isTelephonePrefix = telephonePostfix.some((item) => {
                if (item === phoneFirstTwoDigit) {
                    return true
                }
                return false
            })
            if (valueString.length === 9 && isTelephonePrefix) {
                dataReturn = {
                    valid: true
                }
            } else if (valueString.length === 10 && !isTelephonePrefix) {
                dataReturn = {
                    valid: true
                }
            } else {
                dataReturn = {
                    valid: false,
                    data: {
                        message: 'เบอร์โทรศัพท์ผิดรูปแบบ'
                    }
                }
            }
        } else {
            dataReturn = {
                valid: false,
                data: {
                    message: 'เบอร์โทรศัพท์ผิดรูปแบบ'
                }
            }
        }
    }
    return { ...dataReturn }
}

Validator.extend('phoneNumber', {
    validate: phone,
    getMessage: (field, params, data) => data.message
})
export default {
    name: 'dialogShopOrderMobile',
    components: { dialogCreateShipment },
    mixins: [MixinThailandUtility, MixinOrderUtility],
    props: {
        dialogShopOrder: {
            type: Object
        }
    },
    $_veeValidate: {
        validator: 'new' // give me my own validator scope.
    },
    data () {
        return {
            pagination: {
                limit: 10,
                offset: 0,
                allPage: 1,
                currentPage: 1,
                pageSizes: [10, 20, 50, 100, 200]
            },
            searchAddressTable: [],
            multipleSelection: [],
            itemList: [],
            itemListTmp: [],
            checkAll: false,
            dialogCreateShipment: {
                dialogShow: false,
                orderItems: []
            },
            statusSelect: [1, 2, 3],
            statusList: [
                { id: 1, name: 'รอดำเนินการ', nameEn: 'pending', count: 0 },
                { id: 2, name: 'เตรียมตัวส่ง', nameEn: 'prepareToShip', count: 0 },
                { id: 3, name: 'พร้อมจัดส่ง', nameEn: 'readyToShip', count: 0 }
            ],
            editArray: true,
            statusSave: [
                { id: true, name: 'บันทึก', nameEn: 'edit', count: 0 },
                { id: false, name: 'ไม่บันทึก', nameEn: 'noEdit', count: 0 }

            ],
            printStatusSelect: false,
            statusPrint: [
                { id: 1, name: 'ปริ้นแล้ว', nameEn: 'no_edit_print', count: 0, value: true },
                { id: 2, name: 'ยังไม่ปริ้น', nameEn: 'no_edit_no_print', count: 0, value: false }
            ],
            isActiveSaveButtom: [],
            addressInfo: [],
            searchAddressLoading: false,
            // addressInvalid: [],
            zipcodeInvalid: [],
            provinceInvalid: [],
            districtInvalid: [],
            subDistrictInvalid: [],
            isLoadingCheckAddress: [],
            objZipcodeAlert: {
                '81180': 'อ่าวนาง เปิดให้บริการส่งเฉพาะหมู่ 1-6 เท่านั้น ส่วนหมู่ 7 และ 8',
                '81000': 'อ่าวนาง เปิดให้บริการส่งเฉพาะหมู่ 1-6 เท่านั้น ส่วนหมู่ 7-8 และเกาะพีพี',
                '20180': 'เกาะแสมสาร เกาะครามใหญ่',
                '81120': 'เกาะกลาง',
                '82190': 'เกาะคอเขา',
                '23170': 'เกาะช้างใต้ และเกาะหวาย',
                '83000': 'พรุใน และเกาะมะพร้าว',
                '84220': 'เกาะส้ม และเกาะนก',
                '82000': 'เกาะปันหยี',
                '85000': 'เกาะพยาม',
                '82150': 'เกาะพระทอง',
                '86150': 'เกาะพิทักษ์',
                '92110': 'เกาะลิบง และเกาะมุก',
                '81130': 'เกาะศรีบอยา',
                '91000': 'เกาะสาหร่าย และเกาะหลีเป๊ะ',
                '92120': 'เกาะสุกร',
                '23000': 'เกาะกูด และเกาะหมาก'
            }
        }
    },
    watch: {
        'dialogShopOrder.dialogShow' (val) {
            this.zipcodeInvalid = []
            this.provinceInvalid = []
            this.districtInvalid = []
            this.subDistrictInvalid = []
            if (val) {
                this.fetchOrder()
            } else {
                this.itemList = []
                this.pagination = {
                    limit: 10,
                    offset: 0,
                    allPage: 1,
                    currentPage: 1
                }
                this.multipleSelection = []
                this.searchAddressTable = new Array(0)
                this.checkAll = false
                this.statusSelect = [1, 2, 3]
                this.printStatusSelect = false
                this.editArray = true
            }
        },
        itemList: {
            immediate: true,
            handler (orderInfo) {
                let address = []
                let orderNumberInfo = []
                orderInfo.forEach(e => {
                    orderNumberInfo.push(e.orderNumber)
                    let info = {
                        order_number: e.orderNumber,
                        address: {
                            zipcode: e.shippingZipcode,
                            province: e.shippingProvince,
                            district: e.shippingDistrict,
                            sub_district: e.shippingSubDistrict
                        }
                    }
                    address.push(info)
                })
                let param = {
                    data: address
                }
                this.verifyAddressInfo(param, orderNumberInfo)
            }
        }
    },
    computed: {
        permission: get('permission'),
        diableOrderStatusFalse () {
            if (!this.editArray) {
                return false
            } else {
                return true
            }
        }
    },
    methods: {
        onSelectStatus (val) {
            this.fetchOrder()
        },
        handleOrderNumberDetail (orderNumber) {
            let route = this.$router.resolve({
                path: `/oms/logOrder/LogOrderDetail`,
                query: { orderId: orderNumber }
            })
            window.open(route.href, '_blank') // New tab
        },
        changeLimitPage (val) {
            this.pagination.limit = val
            this.fetchOrder()
        },
        changeCurrentPage (val) {
            this.pagination.offset = this.pagination.currentPage * this.pagination.limit - this.pagination.limit
            this.fetchOrder()
        },
        handleSelectionChange (val) {
            // this.multipleSelection = val
        },
        handleSelectionChangeCheckAll () {
            if (this.checkAll) {
                // this.multipleSelection = []
                this.itemList.forEach(e => {
                    this.multipleSelection.push({ ...e })
                })
            } else {
                // this.multipleSelection = []
                this.itemList.forEach(e => {
                    if (this.multipleSelection.findIndex(x => x.orderNumber === e.orderNumber) !== -1) {
                        this.multipleSelection.splice(this.multipleSelection.findIndex(x => x.orderNumber === e.orderNumber), 1)
                    }
                })
            }
        },
        async handleSelect (item, index) {
            this.itemList[index].shippingProvince = item.provinceName
            this.itemList[index].shippingDistrict = item.districtName
            this.itemList[index].shippingSubDistrict = item.subDistrictName
            this.itemList[index].shippingZipcode = String(item.detail)
            await this.confirmAddressInfo(this.itemList[index], index)
        },
        async validateForm (formName, index) {
            this.itemList[index].loading = true
            if (this.itemList[index].shippingZipcode !== '') {
                await this.confirmAddressInfo(this.itemList[index], index)
            }
            this.checkZipcodeScgAlert(index)
            this.$validator.validateAll(formName).then(async (result) => {
                if (result && this.zipcodeInvalid[index] && this.provinceInvalid[index] && this.districtInvalid[index] && this.subDistrictInvalid[index]) {
                    // this.$loading()
                    // const zipcode = parseInt(this.itemList[index].shippingZipcode)
                    if (this.itemList[index].courierId === 10) {
                        try {
                            // let resCheckZIpcode = await fgApi.order.checkZipcode(`courier_id=${this.detail.orderDetail.courierId}&sub_district=${this.detail.subdistrict}&zipcode=${this.detail.zipcode}&is_mobile=true`)
                            let resCheckZIpcode = await fgApi.order.checkZipcode(`courier_id=${this.itemList[index].courierId}&sub_district=${this.itemList[index].shippingSubDistrict}&zipcode=${this.itemList[index].shippingZipcode}&is_mobile=false`)
                            // console.log(resCheckZIpcode)
                            if (!resCheckZIpcode.success) {
                                this.$loading().close()
                                this.$alert('ออเดอร์นี้จัดส่งโดย BEE: รหัสไปรษณีย์ไม่ได้อยู่ในขอบเขตการให้บริการ', 'แจ้งเตือน', {
                                    confirmButtonText: 'ปิด',
                                    type: 'warning'
                                })
                                return
                            }
                        } catch (error) {
                            this.$message({
                                message: error,
                                type: 'error'
                            })
                        }
                    } else {
                        let checkCovid = await this.checkCovidZipcode(index)
                        if (!checkCovid) return
                    }
                    try {
                        let resCheckZIpcode = await fgApi.order.checkZipcode(`courier_id=${this.itemList[index].courierId}&sub_district=${this.itemList[index].shippingSubDistrict}&zipcode=${this.itemList[index].shippingZipcode}`)
                        if (resCheckZIpcode.success) {
                            let checkReprint = {
                                shippingPhoneNumber: this.itemList[index].shippingPhoneNumber,
                                shippingDistrict: this.itemList[index].shippingDistrict,
                                shippingProvince: this.itemList[index].shippingProvince,
                                shippingSubDistrict: this.itemList[index].shippingSubDistrict,
                                shippingZipcode: this.itemList[index].shippingZipcode,
                                shippingAddress: this.itemList[index].shippingAddress
                            }
                            let checkReprintTmp = {
                                shippingPhoneNumber: this.itemListTmp[index].shippingPhoneNumber,
                                shippingDistrict: this.itemListTmp[index].shippingDistrict,
                                shippingProvince: this.itemListTmp[index].shippingProvince,
                                shippingSubDistrict: this.itemListTmp[index].shippingSubDistrict,
                                shippingZipcode: this.itemListTmp[index].shippingZipcode,
                                shippingAddress: this.itemListTmp[index].shippingAddress
                            }
                            if (JSON.stringify(checkReprint) !== JSON.stringify(checkReprintTmp)) {
                                this.itemList[index].isReprint = true
                                this.itemList[index].isPrint = false
                            }
                            try {
                                let param = {
                                    is_app_edit: true,
                                    note: this.itemList[index].note,
                                    orderNumber: this.itemList[index].orderNumber,
                                    shippingAddress: this.itemList[index].shippingAddress,
                                    shippingDistrict: this.itemList[index].shippingDistrict,
                                    shippingName: this.itemList[index].shippingName,
                                    shippingPhoneNumber: this.itemList[index].shippingPhoneNumber,
                                    shippingProvince: this.itemList[index].shippingProvince,
                                    shippingSubDistrict: this.itemList[index].shippingSubDistrict,
                                    shippingTag: this.itemList[index].shippingTag,
                                    shippingZipcode: this.itemList[index].shippingZipcode,
                                    shopId: this.itemList[index].shopId,
                                    isReprint: this.itemList[index].isReprint,
                                    isPrint: this.itemList[index].isPrint,
                                    adminEmail: this.$store.get('user/objUser').email,
                                    courierId: this.itemList[index].courierId

                                }
                                let res = await fgApi.log.updateAddressOrderMobile(param)
                                if (res.success) {
                                    this.itemList[index].isAppEdit = true
                                    let paramLog = {
                                        addresses: [
                                            {
                                                orderNumber: this.itemList[index].orderNumber,
                                                address: this.itemList[index].shippingAddress,
                                                district: this.itemList[index].shippingDistrict,
                                                name: this.itemList[index].shippingName,
                                                phoneNumber: this.itemList[index].shippingPhoneNumber,
                                                phoneNumberSec: '',
                                                province: this.itemList[index].shippingProvince,
                                                subDistrict: this.itemList[index].shippingSubDistrict,
                                                zipcode: this.itemList[index].shippingZipcode,
                                                rawAddress: this.itemList[index].rawAddress
                                            }
                                        ]
                                    }
                                    fgApi.log.logUpdateAddressOrderMobile(paramLog)
                                    // this.$emit('onSearch', true)
                                    // this.$loading().close()
                                    this.itemList[index].loading = false
                                    this.$notify.success({
                                        title: 'Update Success',
                                        message: `Order number : ${this.itemList[index].orderNumber}`
                                    })
                                } else {
                                    this.$notify.error({
                                        title: `Error ${res.message} `,
                                        message: `Order number :${this.itemList[index].orderNumber}`
                                    })
                                }
                            } catch (error) {
                                this.$notify.error({
                                    title: 'Error',
                                    message: 'API Error ! :' + error
                                })
                            }
                        } else {
                            let text = ''
                            if (this.itemList[index].courierId === 1) {
                                text = 'ออเดอร์นี้จัดส่งโดย SCG : รหัสไปรษณีย์ไม่ได้อยู่ในขอบเขตการให้บริการ'
                            } else {
                                text = 'รหัสไปรษณีย์ไม่ได้อยู่ในขอบเขตการให้บริการ'
                            }
                            this.$alert(text, 'Warning', {
                                confirmButtonText: 'OK',
                                type: 'warning',
                                center: true,
                                callback: action => {
                                    // this.$message({
                                    //     type: 'info',
                                    //     message: `action: ${action}`
                                    // })
                                    console.log('close dialog')
                                }
                            })
                        }
                    } catch (error) {
                        this.$message({
                            type: 'info',
                            message: `${error}`
                        })
                    }

                    this.itemList[index].loading = false
                }
            })
            this.itemList[index].loading = false
        },
        async fetchOrder () {
            let loadingAddUser = this.$loading({
                target: '.loadingShopOrderMobile',
                text: 'กำลังโหลดข้อมูล . . .'
            })
            try {
                let param = {
                    from: this.dialogShopOrder.date,
                    to: this.dialogShopOrder.date,
                    search: '',
                    offset: this.pagination.offset,
                    limit: this.pagination.limit,
                    shop_id: this.dialogShopOrder.detail.shopId,
                    courier_id: this.dialogShopOrder.detail.courierId,
                    status_array: this.statusSelect,
                    isAppEditArray: [this.editArray],
                    isPressPrint: this.printStatusSelect
                }
                // console.log(param)
                let res = await fgApi.log.searchMobileAllOrder(param)
                // console.log(res)
                if (res.success) {
                    this.pagination.allPage = res.allPage
                    let result = res.data.map(e => {
                        return { loading: false, ...e }
                    })
                    this.itemList = [...result]
                    this.itemListTmp = JSON.parse(JSON.stringify(this.itemList))
                    this.searchAddressTable = new Array(this.itemList.length).fill('')
                    this.statusList[0].count = res.status.pending
                    this.statusList[1].count = res.status.prepareToShip
                    this.statusList[2].count = res.status.readyToShip

                    this.statusSave[0].count = res.status.edit
                    this.statusSave[1].count = res.status.noEdit

                    this.statusPrint[0].count = res.status.noEditPrint
                    this.statusPrint[1].count = res.status.noEditNoPrint
                }
            } catch (error) {
                this.$notify.error({
                    title: 'Error',
                    message: 'API Error !'
                })
            }
            loadingAddUser.close()
        },
        createShipment () {
            if (this.multipleSelection.length > 0) {
                let listOrder = []
                var outObject = this.multipleSelection.reduce(function (a, e) {
                    let estKey = e['shopId'];
                    (a[estKey] ? a[estKey] : (a[estKey] = null || [])).push(e)
                    return a
                }, {})
                Object.values(outObject).forEach(e => {
                    let orders = e.map(e => {
                        return {
                            orderNumber: e.orderNumber,
                            status: e.orderStatus,
                            shippingDistrict: e.shippingDistrict,
                            shippingProvince: e.shippingProvince,
                            shippingSubDistrict: e.shippingSubDistrict,
                            courierId: e.courierId
                        }
                    })
                    listOrder.push({
                        orderNumbers: orders,
                        shopId: e[0].shopId,
                        shopName: e[0].shopName
                    })
                })
                const groupBy = key => array =>
                    array.reduce((objectsByKeyValue, obj) => {
                        const value = obj[key]
                        objectsByKeyValue[value] = (objectsByKeyValue[value] || []).concat(obj)
                        return objectsByKeyValue
                    }, {})
                const groupByStatus = groupBy('status')
                listOrder.forEach((e, index) => {
                    let groupStatus = groupByStatus(e.orderNumbers)
                    listOrder[index]['groupStatus'] = groupStatus
                })
                this.dialogCreateShipment.itemList = listOrder
                this.dialogCreateShipment.dialogShow = true
                this.dialogCreateShipment.detail = this.multipleSelection
            } else {
                this.$notify.error({
                    title: 'Error',
                    message: 'กรุณาเลือกออเดอร์'
                })
            }
        },
        onRefreshAllOrder () {
            this.checkAll = false
            this.multipleSelection = []
            this.fetchOrder()
            this.$emit('refreshShopList')
        },
        async confirmAddressInfo (orderInfo, index) {
            this.$set(this.isLoadingCheckAddress, index, true)
            let param = {
                data: [{
                    order_number: orderInfo.orderNumber,
                    address: {
                        zipcode: orderInfo.shippingZipcode,
                        province: orderInfo.shippingProvince,
                        district: orderInfo.shippingDistrict,
                        sub_district: orderInfo.shippingSubDistrict
                    }
                }]
            }
            let verifyAddress = await fgApi.order.verifyAddress(param)
            for (let key in verifyAddress.data) {
                let element = verifyAddress.data[key]
                this.$set(this.zipcodeInvalid, index, element.zipcode)
                this.$set(this.subDistrictInvalid, index, element.subDistrict)
                this.$set(this.districtInvalid, index, element.district)
                this.$set(this.provinceInvalid, index, element.province)
            }
            this.$set(this.isLoadingCheckAddress, index, false)
        },
        async verifyAddressInfo (param, orderNumber) {
            orderNumber.forEach((e, index) => {
                this.$set(this.isLoadingCheckAddress, index, true)
            })
            let verifyAddress = await fgApi.order.verifyAddress(param)
            for (let key in verifyAddress.data) {
                let element = verifyAddress.data[key]
                let index = orderNumber.indexOf(key)
                this.$set(this.zipcodeInvalid, index, element.zipcode)
                this.$set(this.subDistrictInvalid, index, element.subDistrict)
                this.$set(this.districtInvalid, index, element.district)
                this.$set(this.provinceInvalid, index, element.province)
            }
            orderNumber.forEach((e, index) => {
                this.$set(this.isLoadingCheckAddress, index, false)
            })
        },
        async fetchAddressInfoFromDatabase (param) {
            this.searchAddressLoading = true
            try {
                let resSearchAddressInfo = await fgApi.order.searchZipcode(param)
                if (resSearchAddressInfo.success) {
                    this.addressInfo = resSearchAddressInfo.data.zipcode
                } else {
                    console.error('Api sent data failed!!')
                }
            } catch (error) {
                console.error(error)
            }
            this.searchAddressLoading = false
        },
        getAddressInfoFromdataBase (queryString, cb) {
            if (queryString !== '') {
                let param = {
                    search: queryString
                }
                clearTimeout(this.timeout)
                this.timeout = setTimeout(async () => {
                    await this.fetchAddressInfoFromDatabase(param)
                    cb(this.addressInfo)
                }, 500)
            } else {
                return true
            }
        },
        checkZipcodeScgAlert (index) {
            if (this.itemList[index].courierId === 1) {
                if (this.objZipcodeAlert.hasOwnProperty(this.itemList[index].shippingZipcode)) {
                    // let txtShow = `${this.objZipcodeAlert[this.itemList[index].shippingZipcode]} อยู่นอกพื้นที่ให้บริการค่ะ` /
                    this.$confirm(`${this.objZipcodeAlert[this.itemList[index].shippingZipcode]} อยู่นอกพื้นที่ให้บริการค่ะ`, `เฉพาะขนส่ง SCG Express`, {
                        confirmButtonText: 'OK',
                        type: 'warning',
                        center: true,
                        showCancelButton: false
                    }).then(() => {
                    })
                }
            }
        },
        async autoSetupSearchAddress (evt, index) {
            let paste = (event.clipboardData || window.clipboardData).getData('text')
            this.$set(this.searchAddressTable, index, paste.trim())
            this.$refs[`txt_autoCompleteSelectAddress${index}`][0].loading = true
            await this.fetchAddressInfoFromDatabase({ search: paste.trim() })
            this.$refs[`txt_autoCompleteSelectAddress${index}`][0].suggestions = this.addressInfo
            this.$refs[`txt_autoCompleteSelectAddress${index}`][0].loading = false
        },
        flashCurrierMaxLength (item) {
            // console.log(item, COURIER_FLASH.id)
            if (item.courierId === COURIER_FLASH.id) {
                return 50
            } else {
                return 200
            }
        },
        async checkCovidZipcode (index) {
            const param = {
                courierId: this.itemList[index].courierId,
                subDistrict: this.itemList[index].shippingSubDistrict,
                district: this.itemList[index].shippingDistrict,
                province: this.itemList[index].shippingProvince
            }
            let res = await fgApi.order.checkCovidAddress(param)
            console.log(res)
            if (!res.success) {
                if (res.data.courierId === 1) {
                    let textAlert = `
                            เนื่องจากมีประกาศฉุกเฉินห้ามประชาชนเข้าพื้นที่เสี่ยงใน
                            ตำบล ${this.itemList[index].shippingSubDistrict} อำเภอ ${this.itemList[index].shippingDistrict} จังหวัด ${this.itemList[index].shippingProvince}
                            ส่งผลให้ SCG EXPRESS ไม่สามารถเข้ารับ และ ส่งพัสดุในพื้นที่ดังกล่าวได้
                        `
                    this.$alert(textAlert, 'Warning', {
                        confirmButtonText: 'OK',
                        type: 'warning',
                        center: true,
                        callback: action => {
                            this.itemList[index].loading = false
                            return false
                        }
                    })
                } else if (res.data.courierId === 4 && res.data.type === 3) {
                    let textAlert = `
                            เนื่องจากมีประกาศฉุกเฉินห้ามประชาชนเข้าพื้นที่เสี่ยงใน
                            ตำบล ${this.itemList[index].shippingSubDistrict} อำเภอ ${this.itemList[index].shippingDistrict} จังหวัด ${this.itemList[index].shippingProvince}
                            ส่งผลให้ Flash express ไม่สามารถเข้ารับ และ ส่งพัสดุในพื้นที่ดังกล่าวได้
                        `
                    this.$alert(textAlert, 'Warning', {
                        confirmButtonText: 'OK',
                        type: 'warning',
                        center: true,
                        callback: action => {
                            this.itemList[index].loading = false
                            return false
                        }
                    })
                } else {
                    return true
                }
            } else {
                return true
            }
        }
    }
}
</script>

<style lang="scss">

.dividerAddress .el-divider--vertical{
    height: 450px;
}
.sub-title{
    margin-top:5px;
    font-weight: bold;
}
.tableMobile{
    table {
        border-collapse: collapse;
        border-spacing: 0;
        width: 100%;
        border: 1px solid #ddd;
    }
    th, td {
        text-align: left;
        padding: 8px;
    }
    thead{
        th, td {
        background-color:black;
        color:white;
        }
    }

    tr:nth-child(even){background-color: #f2f2f2}
    .el-form-item__error {
        color: #F56C6C;
        font-size: 12px;
        line-height: 1;
        padding-top: 4px;
        position: unset;
        top: 100%;
        left: 0;
    }
    .input-is-error{
        border-color: #f56c6c;
    }
}
</style>
